__turbopack_context__.v({
  "card": "AuthModalLayout-module-scss-module__oeo-6G__card",
  "close": "AuthModalLayout-module-scss-module__oeo-6G__close",
  "logo": "AuthModalLayout-module-scss-module__oeo-6G__logo",
});
